import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Defer setState to avoid re-entering React's error handling (fixes "Maximum call stack size exceeded"
    // when the error boundary callback triggers another update in the same commit).
    const err = error;
    const info = errorInfo;
    const setErrorState = () => {
      this.setState(prev => (prev.hasError ? { ...prev, error: err, errorInfo: info } : null));
    };
    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(setErrorState);
    } else {
      setTimeout(setErrorState, 0);
    }
    // Always log - this is the only way to see the original error in production
    console.error('[platform-public] ErrorBoundary caught:', error && error.message, error && error.stack && error.stack.split('\n')[1]);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error">
          <h2>Oops! Something went wrong</h2>
          <p className="error-message">
            We're sorry, but something went wrong. Please refresh the page or try again later.
          </p>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ whiteSpace: 'pre-wrap', color: 'white', marginTop: '1rem' }}>
              <summary>Error Details (Development Mode)</summary>
              <p>{this.state.error && this.state.error.toString()}</p>
              <p>{this.state.errorInfo?.componentStack ?? 'No stack trace'}</p>
            </details>
          )}
          <button 
            className="auth-button" 
            onClick={() => window.location.reload()}
            style={{ marginTop: '1rem' }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;